<oph-button
  appearance="outline"
  color="gray"
  [style]="{color: 'var(--brown-med)', width: '100%'}"
  (buttonClick)="back.emit()"
  class="back-button"
  >Back</oph-button
>

<oph-button
  appearance="outline"
  color="gray"
  [disabled]="disabled"
  [style]="{color: 'var(--brown-med)', width: '100%', background: 'var(--lightest)'}"
  (buttonClick)="newSubtask.emit()"
>
  <img src="assets/img/icons/plus-orange.svg" />
  Subtask
</oph-button>

<oph-button
  [loading]="loadingSave"
  [disabled]="disabled || loadingSave"
  appearance="solid"
  color="green"
  [style]="{width: '136px'}"
  (buttonClick)="finish.emit()"
  class="next-button"
>
  Finish
  <img src="assets/img/icons/chevron-right-white.svg" />
</oph-button>
